define('collections/comments',[
  "globals",
  "backbone",
  "models/comments",
  "URIjs"
], function (globals, Backbone, CommentModel, URI) {
  "use strict";

  var CommentList = Backbone.Collection.extend({
    initialize: function () {
      this.baseURL = $("#comments").data("comment-base");
    },

    sortWith: function (comparator) {
      return new CommentList(this.clone().toJSON(), {
        comparator: comparator,
        model: CommentModel
      }).sort();
    },

    filterBy: function (iteratee) {
      return new CommentList(this.filter(iteratee), {
        comparator: this.comparator,
        model: CommentModel
      });
    },

    url: function () {
      if (globals.content) {
        return URI.joinPaths(
          this.baseURL,
          globals.getLibrary(),
          globals.getVersion(),
          globals.getLanguage(),
          globals.getPath()
        ).path();
      } else {
        return this.baseURL;
      }
    }
  });

  return CommentList;
});

